import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
} from "@progress/kendo-react-grid";
import { useNavigate } from 'react-router-dom';
import "./tablestyles.scss";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";



const CandidateTimeSheet = (Props: any) => {

  const navigate = useNavigate()

  const checkStatus = (status: string) => {
    switch (status) {
        case '2':
            return {
                value: 'Pending',
                class: 'statusMessage Yellow'
            }
        case '3':
            return {
                value: 'Approved',
                class: 'statusMessage Green'
            }
        case '4':
            return {
                value: 'Rejected',
                class: 'statusMessage Red'
            }
        default:
            return {
                value: '',
                class: ''
            }
    }
  }

  
    const statusCell = (props: GridCellProps) => {
        return (
            <td>
                <div className={checkStatus(props.dataItem.timesheetStatus).class}>
                    {checkStatus(props.dataItem.timesheetStatus).value}
                </div>
            </td>
        )
    }

    const historyCell = (props: GridCellProps) => {
        return (
            <td>
                <Link to={''} onClick={() => Props.showHistory(props.dataItem)}><Icon icon="bx:history"width="25" style={{'color':'rgba(0, 0, 0, 0.6)'}} ></Icon></Link>
            </td>
        )
    }
  

  return (
    <div className="tableStyle no-min-height no-top-padd">
        <Grid
            data={Props.data}           
        >
        <GridNoRecords>
            <div className="noData">
              <Icon icon="mdi:smiley-neutral-outline" />
              No data to display
            </div>
        </GridNoRecords>
        <Column field="duration" width="270px"  title="Duration" cell={durationCell}/>
        <Column field="project" title="Project"  width="160px" cell={projectCell}/>
        <Column field="submittedOn" title="Submitted On" width="145px"  cell={submittedOnCell}/>
        <Column field="submittedTo" title="Submitted To"  cell={submittedToCell}/>
        <Column field="reportingManager" title="Reporting Manager" cell={reportingManagerCell}/>
        <Column field="verifiedBy" title="Verified By" cell={verifiedByCell}/>
        <Column field="status" title="Status" width="75px" cell={statusCell}/>
        <Column cell={historyCell} width="50px"/>
        <Column cell={ViewButton}  title="" width="120px"/>
        </Grid>  
    </div>
  )
}

export default CandidateTimeSheet

const durationCell = (props: GridCellProps) => {
    
    let startDate = new Date(parseInt(props.dataItem.startDate)).toDateString().slice(3);
    let endDate   = new Date(parseInt(props.dataItem.endDate)).toDateString().slice(3);
    return (
        <td>
            {startDate} - {endDate}
        </td>
    )
}

const projectCell = (props: GridCellProps) => {
  
    return (
        <td>
            {props.dataItem.projectName}
        </td>
    )
}

const submittedOnCell = (props: GridCellProps) => {

    let date = new Date(parseInt(props.dataItem.submittedOn)).toDateString();
    return (
        <td>
            {date}
        </td>
    )
}

const submittedToCell= (props: GridCellProps) => {
  
    return (
        <td className="break-all">
            {props.dataItem.reportingManagerEmail}
        </td>
    )
}

const verifiedByCell = (props: GridCellProps) => {
  
    return (
        <td className="break-all">
            {props.dataItem.verifiedBy}
        </td>
    )
}

// const statusCell = (props: GridCellProps) => {
  
//     return (
//         <td>
//             <div className="statusMessage Yellow">
//                 {props.dataItem.status !== "Approved" || props.dataItem.status !== "Rejected " ? "Pending" : props.dataItem.status}
//             </div>
//         </td>
//     )
// }


const reportingManagerCell = (props: GridCellProps) => {
  
    return (
        <td>
            {props.dataItem.reportingManagerName}
        </td>
    )
}

const ViewButton = (props: GridCellProps) => {    
   
    const navigate = useNavigate()
    return (
      <td>
        <button onClick={(e: any) => navigate('../timesheethistory', { state: { candidateJobId: props.dataItem.candidateJobId , candidateName: props.dataItem.candidateName , projectId: props.dataItem.projectId , timesheetId: props.dataItem.timesheetId , position: props.dataItem.position , candidateData: props.dataItem}})} className="link-btn">
          View Timesheet
        </button> 
    </td>
    );
  }